import { render } from "./SideMenu.vue?vue&type=template&id=4113e6f6&scoped=true"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"

import "./SideMenu.vue?vue&type=style&index=0&id=4113e6f6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4113e6f6"
/* hot reload */
if (module.hot) {
  script.__hmrId = "4113e6f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4113e6f6', script)) {
    api.reload('4113e6f6', script)
  }
  
  module.hot.accept("./SideMenu.vue?vue&type=template&id=4113e6f6&scoped=true", () => {
    api.rerender('4113e6f6', render)
  })

}

script.__file = "src/views/payments/modules/SideMenu.vue"

export default script